import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Utils from "../../../utility";
import { topBuyerService } from "../../../services/index";
import Loader from "../../../common/components/tablesLoader";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 356,
    minHeight:356
    // marginBottom: "25px",
    // overflowY: "hidden",
  },
  Card: {
    maxHeight: 100,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },
});
function createData(
  Account_Name,
  Account_Id,
  Collected,
  Total_Purchased_Value
) {
  return { Account_Name, Account_Id, Collected, Total_Purchased_Value };
}

const rows = [
  {
    User_dp: "/images/profileIcon.svg",
    Account_Name: "sachin",
    Account_Id: "1",
    Collected: "1",
    Total_Purchased_Value: "",
  },
  {
    User_dp: "/images/profileIcon.svg",
    Account_Name: "sachin",
    Account_Id: "1",
    Collected: "1",
    Total_Purchased_Value: "",
  },
  {
    User_dp: "/images/profileIcon.svg",
    Account_Name: "sachin",
    Account_Id: "1",
    Collected: "1",
    Total_Purchased_Value: "",
  },
  {
    User_dp: "/images/profileIcon.svg",
    Account_Name: "sachin",
    Account_Id: "1",
    Collected: "1",
    Total_Purchased_Value: "",
  },
];

export default function BasicTable() {
  
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();
  const [topBuyer, setTopBuyer] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);
  useEffect(() => {
    getTopBuyer();
  }, []);
  const getTopBuyer = async () => {
    let [error, nftTopBuyer] = await Utils.parseResponse(
      topBuyerService.getTopBuyer()
    );
    if (error || !nftTopBuyer) return;
    setTopBuyer(nftTopBuyer);
    setLoading(false);
  };
 
  const history = useHistory();

  return (
    <Paper elevation={0} className={classes.root}>
      <Card elevation={0} className={classes.Card}>
        <Grid container spacing={1} style={{ height: 47 }}>
          <Grid item xs={3}>
            <Paper elevation={0} id="paper-top">
              <Link
                href="#"
                onClick={preventDefault}
                style={{ textDecoration: "none" }}
                id="top-seller"
              >
                Top NFT Buyers
              </Link>
            </Paper>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}>
            <Paper elevation={0} id="paper-view">
              <Link
                // onClick={()=>history.push('/home/nftbuyer')}
                href="/home/nftbuyer"
                style={{ textDecoration: "none" }}
                id="view-all"
              >
                View All
              </Link>
            </Paper>
          </Grid>
        </Grid>
      </Card>
      <Divider />

      <TableContainer className={classes.container} id="scrollbar-8"
       >
        <Table stickyHeader aria-label="sticky table" className="Table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                id="Table-cell"
                className="w-4 border-bottom"
              ></TableCell>
              <TableCell align="left" id="Table-cell" className="w-24">
                Account Name
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-24">
                Account ID
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-24">
                Collected
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-24">
                Total Purchased Value(XDC)
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody className="table-body" 
          //className="table-body scrollbar"
          //id="scrollbar-7"
          >
            {isLoading ? (
              <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homeSellBuyTable">
                    <Loader />
                  </div>
                </TableCell>
              </TableRow>
            ) : (topBuyer.length !== 0?
              topBuyer.map((row) => (
                <TableRow className="table-row" >
                  <TableCell align="left" className="border-bottom">
                    <img
                      alt=""
                      style={{ width: 30, height: 30, borderRadius: "15px" }}
                      src={row?.photo[0] || "/defaultprofile.png"}
                    />
                  </TableCell>
                  <TableCell
                    className="Table-cell"
                    align="left"
                    style={{ width: 473 }}
                  >
                    {row?.name[0] || "-"}
                  </TableCell>
                  <TableCell
                    align="left"
                    className="Table-cell"
                    style={{ width: 838 }}
                  >
                    {row?.userId[0] || "-"}
                  </TableCell>
                  <TableCell
                    align="left"
                    className="Table-cell"
                    style={{ width: 744 }}
                  >
                    {row?.sold || ""}
                  </TableCell>
                  <TableCell
                    align="left"
                    className="Table-cell"
                    style={{ width: 435 }}
                  >
                    {row.totalSellValue || "-"}
                  </TableCell>
                </TableRow>
              )):( <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homeSellBuyTable">
                    <center>No data found</center>
                  </div>
                </TableCell>
              </TableRow>)
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
